import {
    SET_COMPANY_CONFIG,
    SET_WHITE_STAR_VALUES,
} from './types/mutations';

const mutations = {
    [SET_COMPANY_CONFIG](state, payload) {
        state.companyConfig = payload;
    },
    [SET_WHITE_STAR_VALUES](state, payload) {
        state.whiteStarValues = payload;
    },
};

export default mutations;
